export default __webpack_public_path__ + "static/media/a8.ffbaab32.png";